import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  // endpointLogin: '',
  // endpointLogout: '',
  isAuthenticated: false,
  user: {
    isSuspended: undefined,
    isAdministrator: false,
    username: "",
    sub: "",
    roles: [],
    groups: [],
    firstname: "",
    lastname: "",
    email: "",
    token: ""
  },
  tasksCount: 0
}

// const getters = {
//   // doneTodos: state => {
//   //   return state.todos.filter(todo => todo.done)
//   // }
//   token (state) {
//     return state.user.token
//   },
// }

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  logout(state) {
    state.isAuthenticated = false
    state.user.isAdministrator = false
    state.user.isSuspended = true
    state.user.username = ""
    state.user.sub = ""
    state.user.roles = []
    state.user.groups = []
    state.user.firstname = ""
    state.user.lastname = ""
    state.user.email = ""
    state.user.token = ""
  },
  login(state, [token, tokenParsed]) {
    state.isAuthenticated = true
    state.user.token = token
    state.user.username = tokenParsed.preferred_username
    state.user.sub = tokenParsed.sub
    state.user.groups = tokenParsed.groups
    state.user.firstname = tokenParsed.given_name
    state.user.lastname = tokenParsed.family_name
    state.user.email = tokenParsed.email
    if (tokenParsed.resource_access.hasOwnProperty(config.keycloak.resourceAccess)) {
      let roles = tokenParsed.resource_access[config.keycloak.resourceAccess].roles
      state.user.roles = roles
      if (roles.includes(config.keycloak.adminRole)) {
        state.user.isAdministrator = true
      }
    }
  },
  updateSuspended(state, [ isSuspended ]) {
    state.user.isSuspended = isSuspended
  },
  updateToken(state, [ token ]) {
    // console.log('store update: ', token)
    state.user.token = token
  }
}

export default new Vuex.Store({
  state,
  mutations
})